import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import classes from './Educator.module.css';
import { useParams } from 'react-router-dom';

const Educator = (props) => {

  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);

  return (
  <div className={classes.educator}>
    <svg 
    className={classes.square}
    width="3036px" height="3316px">
        <path fillRule="evenodd"  opacity="0.949" fill="rgb(248, 186, 195)"
        d="M2056.455,226.969 L2990.343,2068.157 C3093.773,2272.072 3012.313,2521.224 2808.399,2624.653 L1535.738,3270.173 C1331.824,3373.602 1082.672,3292.143 979.242,3088.228 L45.354,1247.040 C-58.076,1043.126 23.384,793.974 227.298,690.544 L1499.959,45.025 C1703.874,-58.405 1953.025,23.054 2056.455,226.969 Z"/>
    </svg>
    <svg
    className={classes.squareMobile}
    width="2561px" height="2373px">
        <path fillRule="evenodd"  opacity="0.949" fill="rgb(248, 186, 195)"
        d="M1087.734,54.890 L2350.764,772.012 C2549.596,884.905 2619.264,1137.608 2506.371,1336.440 L2037.397,2162.420 C1924.504,2361.252 1671.801,2430.920 1472.969,2318.027 L209.939,1600.904 C11.107,1488.012 -58.561,1235.309 54.332,1036.477 L523.307,210.497 C636.199,11.665 888.902,-58.003 1087.734,54.890 Z"/>
    </svg>
    <div className={classes.educator__text}>
        <h1 className={classes.educator__heading}>
          <span className={classes.header}>{props.onTranslate('heading')}</span>
          <span className={classes.header__mobile}>{props.onTranslate('heading__mobile')}</span>
        </h1>
        <h2 className={classes.educator__description} id="description">
          <strong>
            {props.onTranslate('description__strong')}
          </strong>
          {props.onTranslate('description')}
        </h2>
        <div className={classes.educator__form}>
            <h3 className={classes.educator__formText}>
              <span className={classes.invite__normal}>{props.onTranslate('invite')}</span>
              <span className={classes.invite__mobile}>{props.onTranslate('invite__mobile')}</span>
            </h3>
            <a href="#form" title="do formularza" className={classes.educator__formLink}>
              <svg
              className={classes.educator__formArrow}
              width="53px" height="53px">
              <path fillRule="evenodd"  stroke="rgb(38, 38, 38)" strokeWidth="2px" strokeLinecap="butt" strokeLinejoin="miter" fill="none"
              d="M25.927,2.296 C38.955,2.296 49.516,12.857 49.516,25.885 C49.516,38.913 38.955,49.475 25.927,49.475 C12.899,49.475 2.337,38.913 2.337,25.885 C2.337,12.857 12.899,2.296 25.927,2.296 Z"/>
              <path fillRule="evenodd"  stroke="rgb(38, 38, 38)" strokeWidth="2px" strokeLinecap="butt" strokeLinejoin="miter" fill="none"
              d="M28.790,16.651 L37.543,25.403 L28.790,34.155 "/>
              <path fillRule="evenodd"  fill="rgb(38, 38, 38)"
              d="M12.139,24.728 L37.907,24.728 L37.907,26.975 L12.139,26.975 L12.139,24.728 Z"/>
              </svg>
            </a>
        </div>
    </div>
    <svg
        className={classes.square__empty} 
        width="315px" height="1900px">
        <path fillRule="evenodd"  stroke="rgb(248, 186, 195)" strokeWidth="2px" strokeLinecap="butt" strokeLinejoin="miter" opacity="0.949" fill="none"
        d="M2131.469,265.842 L2883.038,2188.668 C2966.276,2401.625 2861.118,2641.738 2648.161,2724.975 L1319.071,3244.473 C1106.114,3327.710 866.001,3222.552 782.764,3009.596 L31.195,1086.769 C-52.043,873.812 53.115,633.700 266.072,550.462 L1595.162,30.965 C1808.119,-52.273 2048.232,52.885 2131.469,265.842 Z"/>
    </svg>
  </div>
  )
}

export default Educator;